import { DotsThreeIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface DataTableRowActionsProps {
  actions: React.ReactNode;
}

/**
 * @example
 * <DataTableRowActions actions={[
 *  <DropdownMenuItem>Edit</DropdownMenuItem>
 *  <DropdownMenuItem>Make a copy</DropdownMenuItem>
 *  <DropdownMenuItem>Favorite</DropdownMenuItem>
 *  <DropdownMenuSeparator />
 *  <DropdownMenuSub>
 *    <DropdownMenuSubTrigger>Labels</DropdownMenuSubTrigger>
 *    <DropdownMenuSubContent>
 *      <DropdownMenuRadioGroup value={task.label}>
 *          <DropdownMenuRadioItem value="1">
 *            Label 1
 *          </DropdownMenuRadioItem>
 *          <DropdownMenuRadioItem value="2">
 *            Label 2
 *          </DropdownMenuRadioItem>
 *      </DropdownMenuRadioGroup>
 *    </DropdownMenuSubContent>
 *  </DropdownMenuSub>
 *  <DropdownMenuSeparator />
 *  <DropdownMenuItem variant="destructive">
 *    Delete
 *    <DropdownMenuShortcut>⌘⌫</DropdownMenuShortcut>
 *  </DropdownMenuItem>
 * ]} />
 */
export function DataTableRowActions({ actions }: DataTableRowActionsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="data-[popup-open]:bg-muted size-8"
        >
          <DotsThreeIcon />
          <span className="sr-only">
            <T context="screen reader label for row actions dropdown button">
              Open menu
            </T>
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        {actions}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
